module.exports = __webpack_public_path__ + "static/img/product-part3.1602dbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product-part3.png
// module id = phzo
// module chunks = 1